import { create } from 'zustand'

interface AccessGuardState {
    isAccessDenied: boolean
    statusCode?: number
    message?: string
    path?: string
    setAccessDenied: (payload: {
        statusCode?: number
        message?: string
        path?: string
    }) => void
    clearAccessDenied: () => void
}

export const useAccessGuardStore = create<AccessGuardState>(set => ({
    isAccessDenied: false,
    statusCode: undefined,
    message: undefined,
    path: undefined,
    setAccessDenied: ({ statusCode, message, path }) =>
        set({
            isAccessDenied: true,
            statusCode,
            message,
            path,
        }),
    clearAccessDenied: () =>
        set({
            isAccessDenied: false,
            statusCode: undefined,
            message: undefined,
            path: undefined,
        }),
}))
